import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const banksUrl = `${SERVER_API}/banks`;

export const BANKS = {
  ...generateCrudEndpoints(banksUrl),
  HISTORY(id: number) {
    return {
      method: 'GET',
      url: `${banksUrl}/${id.toString()}/history`,
    } as IEndpointData;
  },
};
